import React from 'react';
import { Button, KIND as BUTTON_KIND, SIZE as BUTTON_SIZE } from 'baseui/button';
import { Modal, ModalBody, ModalFooter, ModalHeader, ROLE as MODAL_ROLE, SIZE as MODAL_SIZE } from 'baseui/modal';
import type { StyleObject } from 'styletron-react';
type ModalActionT = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
};
type PropsT = {
  isOpen: boolean;
  title: React.ReactNode;
  children: React.ReactNode;
  actions: ModalActionT[];
  onClose: () => void;
  closeable?: boolean;
  customStyleOverrides?: {
    dialog?: StyleObject;
  };
};
export function ActionModal({
  isOpen,
  title,
  children,
  actions,
  onClose,
  closeable = true,
  customStyleOverrides
}: PropsT) {
  return <Modal onClose={onClose} closeable={closeable} isOpen={isOpen} animate autoFocus size={MODAL_SIZE.auto} role={MODAL_ROLE.dialog} overrides={{
    Dialog: {
      style: customStyleOverrides?.dialog
    }
  }}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter style={{
      paddingBottom: '16px'
    }}>
        {actions.map((action, index) => <Button key={action.label} kind={index === actions.length - 1 ? BUTTON_KIND.primary : BUTTON_KIND.tertiary} size={BUTTON_SIZE.compact} disabled={action.disabled} onClick={action.onClick}>
            {action.label}
          </Button>)}
      </ModalFooter>
    </Modal>;
}